import * as React from 'react';

import s from './redaction.css';

export const Redaction = () =>
  <div className={s['redaction']}>
    <span className={s['redaction__text']}>редакция</span>
    <a className={s['redaction__link']} href="mailto:editorial@cian.ru">editorial@cian.ru</a>
  </div>;
